import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FieldCropsPopupComponent } from './field-crops-popup.component';
import {DxPopupModule} from 'devextreme-angular';
import {FieldCropsGridModule} from '../field-crops-grid/field-crops-grid.module';



@NgModule({
  declarations: [FieldCropsPopupComponent],
  imports: [
    CommonModule,
    DxPopupModule,
    FieldCropsGridModule
  ],
  exports: [FieldCropsPopupComponent]
})
export class FieldCropsPopupModule { }
